module.exports = __webpack_public_path__ + "static/media/checkGreen.2063385e.svg";